import ConditionType from './ConditionType'

const CrossingUpCondition: ConditionType = {
  value: 'crossing up',
  label: 'Crossing Up',
  hasRHS: true,
}

export default CrossingUpCondition
